import { Navigation } from "./navigation";
import { Contact } from "./contact";
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const LucaBarbuti = () => {
    const [data, setData] = useState(null);

    // ---- Função que transforma URLs em <a> ----
    const convertLinks = (text) => {
        if (!text) return text;

        const urlRegex = /(https?:\/\/[^\s]+)/g;

        return text.split(urlRegex).map((part, i) => {
            if (urlRegex.test(part)) {
                return (
                    <a
                        key={i}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };
    // -------------------------------------------

    useEffect(() => {
        setData(JsonData.Medicos.LucaBarbuti);
    }, []);

    if (!data) return null;

    return (
        <>
            <Navigation />

            <div id="medico" className="doctor-page">
                <div className="container">
                    <div className="row align-items-start doctor-row">

                        {/* FOTO */}
                        <div className="col-12 col-md-6">
                            <img
                                src={data.image}
                                className="img-fluid rounded shadow"
                                alt={data.name}
                            />
                        </div>

                        {/* TEXTO */}
                        <div className="col-12 col-md-6">
                            <div className="doctor-text">
                                <h1 className="nome-medico text-center text-md-start">
                                    {data.name}
                                </h1>

                                <p className="white-space-pre-line mt-3">
                                    {convertLinks(data.paragraph)}
                                </p>

                                <div className="qualification-title-wrapper">
                                    <h3 className="qualification-title">Qualificações</h3>
                                    <div className="qualification-underline"></div>
                                </div>

                                <ul className="list-style mt-4">
                                    {data.qualificacoes.map((q, i) => (
                                        <li key={i}>
                                            {convertLinks(q)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Contact data={JsonData.Contact} />
        </>
    );
};
